import {IMacroDistributionResponse} from '../macronutrient-distribution';
import {IDistributionProperty} from '../interfaces/distribution-property.interface';

export class DistributionPropertyG implements IDistributionProperty {
  type: 'grams' | 'percentage' | 'lts';
  block: boolean;
  response: IMacroDistributionResponse;
  grams: string;
  defaultValue: number;
  constructor(
    public title: string,
    public reference: number,
    public value: number,
    public icon: string
  ) {
    this.type = 'grams';
    this.block = false;
    this.defaultValue = value;
  }

  verify(grams: number, total: number): void {
    this.grams = grams.toFixed(2);
    let gramsPercentage = 0;
    if (grams > 0) {
      gramsPercentage = Math.round((grams * 100) / total);
    }
    const referencePercentage = Math.round((this.reference * 100) / (total - grams + this.reference));


    if (gramsPercentage > this.defaultValue) {
      this.response = {
        ...this.response,
        isHigher: true,
        messageChoiceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${gramsPercentage - this.defaultValue}%  a la distribución elegida.`
      };
    } else if (gramsPercentage < this.defaultValue) {
      this.response = {
        ...this.response,
        isLower: true,
        messageChoiceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${this.defaultValue - gramsPercentage}% inferior a la distribución elegida.`
      };
    } else {
      this.response = {
        ...this.response,
        messageChoiceValue: undefined,
      };
    }


    if (this.value > referencePercentage) {
      this.response = {
        ...this.response,
        isHigher: true,
        messageReferenceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${this.value - referencePercentage}% superior a la referencia.`
      };
    } else if (this.value < referencePercentage) {
      this.response = {
        ...this.response,
        isLower: true,
        messageReferenceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${referencePercentage - this.value}% inferior a la referencia.`
      };
    } else {
      this.response = {
        ...this.response,
        messageReferenceValue: undefined,
      };
    }
  }

  getReference(): string {
    return this.reference + '';
  }

  setValue(value: number): void {
    this.value = value;
  }

  setDefaultValue(value: number): void {
    this.defaultValue = value;
  }

  setBlock(value: boolean): void {
    this.block = value;
  }
}
